export enum ChunkType {
    MOBILE_FEED="MOBILE_FEED",
    WEB_FEED="WEB_FEED",
    SCREEN_SHARE="SCREEN_SHARE",
    VERIFY_SURROUNDINGS="VERIFY_SURROUNDINGS"
}